import walk from "./walk";
import { getErrorCode } from "@vortex/shared";
export const IGNORABLE_PREFIXES = ["__vortex", "__merged"];
function getFileList(basePath) {
    const result = [];
    return walk(basePath, (filePath, stats) => {
        if (!IGNORABLE_PREFIXES.some((prefix) => filePath.toLowerCase().startsWith(prefix))) {
            result.push({ filePath, stats });
        }
        return Promise.resolve();
    })
        .then(() => result)
        .catch((err) => {
        const code = getErrorCode(err);
        if (code === "ENOENT") {
            // if the directory doesn't exist it obviously doesn't contain files, right?
            return Promise.resolve([]);
        }
        else {
            return Promise.reject(err);
        }
    });
}
export default getFileList;
